import React from 'react'
import ReactSelect from 'react-select';


const options = [
    { value: 'male', label: 'Male' },
    { value: 'female', label: 'Female' }
];

const customStyles = {
    control: (base, state) => ({
        ...base,
        backgroundColor: '#E4EBF3',
        borderRadius: 0,
        border: 'none',
        boxShadow: 'none',
        minHeight: '50px',
        padding: '0 8px',
        color: '#000',
        fontFamily: 'Maven Pro, sans-serif',
    }),
    placeholder: (base) => ({
        ...base,
        color: '#7a9cb8',
        fontSize: '1rem',
    }),
    singleValue: (base) => ({
        ...base,
        color: '#000',
        fontSize: '1rem',
    }),
    dropdownIndicator: (base) => ({
        ...base,
        color: '#7a9cb8',
    }),
    indicatorSeparator: () => ({
        display: 'none', // remove the little vertical line between text and arrow
    }),
    menu: (base) => ({
        ...base,
        borderRadius: 0,
        marginTop: 0,
    }),
    option: (base, state) => ({
        ...base,
        backgroundColor: state.isFocused ? '#d9e5f0' : 'white',
        color: '#333',
        borderRadius: 0,
        padding: '10px 12px',
    }),
};


export default function SexSelect(props) {
    const errorStyle = {
        border: (props.errorBoolean) ? 'solid 2px #FD625E' : 'solid 2px #E4EBF3'
    }
    return (
        <div className="Select">
            <label className="Select--label" for={props.name}>{props.label}</label>
            <div className="Select--container" style={errorStyle}>
                <ReactSelect
                    options={options}
                    value={props.selectSexData}
                    onChange={props.handleSelectChange}
                    styles={customStyles}
                    placeholder="Select Gender"
                />
            </div>
            {props.errorBoolean && <h4 className="TextBox--error">{props.errorMessage}</h4>}
        </div>
    )
}